import { render, staticRenderFns } from "./TheEnglish.vue?vue&type=template&id=10502cab&"
import script from "./TheEnglish.vue?vue&type=script&lang=js&"
export * from "./TheEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports